<template>
    <div class="servico">
        <!-- Página: Eletricidade Civil e Industrial -->
        <section id="eletricidade" class="servico-section">
            <h2>Eletricidade Civil e Industrial</h2>
            <img src="/images/eletricidade.jpg" alt="Quadro de Distribuição" class="servico-img" />
      <h2>SServiços elétricos para residências, edifícios e indústrias, garantindo segurança e eficiência.</h2>
      <ul class="servico-lista">
        <li><button @click="abrirModal('modal1')">Instalações elétricas em residências, edifícios e unidades industriais</button></li>
        <li><button @click="abrirModal('modal2')">Manutenção preventiva e corretiva de sistemas elétricos</button></li>
        <li><button @click="abrirModal('modal3')">Inspeção e correção de quadros elétricos e sistemas de proteção</button></li>
      </ul>
    </section>

    <!-- Modal 1 -->
    <div v-if="modalAberto === 'modal1'" class="modal-overlay">
      <div class="modal-content">
        <h3>Instalações elétricas em residências, edifícios e unidades industriais</h3>
        <p><strong>Descrição:</strong>: Cabeamento, tomadas, iluminação e quadros trifásicos.</p>
        <p><strong>Benefício:</strong> Sistemas seguros e eficientes, em conformidade com normas locais.</p>
        <p><strong>Exemplo:</strong> Rede elétrica para novo edifício comercial no Lobito</p>
        <p><strong>Prazo:</strong> Simples (1-2 dias); Complexo (1-4 semanas)</p>
        <p><strong>Pagamento:</strong> Simples (completo); Complexo (diagnóstico + parcelado)</p>
        <p><strong>Normas:</strong> IEC 60364, ABNT NBR 5410, CE.</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>

    <!-- Modal 2 -->
    <div v-if="modalAberto === 'modal2'" class="modal-overlay">
      <div class="modal-content">
        <h3>Manutenção preventiva e corretiva de sistemas elétricos</h3>
        <p><strong>Descrição:</strong> Inspeções regulares e reparos de curtos-circuitos ou falhas</p>
        <p><strong>Benefício:</strong> Reduz riscos de acidentes e paradas dispendiosas</p>
        <p><strong>Exemplo:</strong> Manutenção em fábrica no Lobito.</p>
        <p><strong>Prazo:</strong> Simples (2-4 horas); Complexo (1-3 dias).</p>
        <p><strong>Pagamento:</strong>  Simples (completo); Complexo (diagnóstico + parcelado).</p>
        <p><strong>Normas:</strong> IEC 60947, NBR 5410.</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>

    <!-- Modal 3 -->
    <div v-if="modalAberto === 'modal3'" class="modal-overlay">
      <div class="modal-content">
        <h3>Inspeção e correção de quadros elétricos e sistemas de proteção</h3>
        <p><strong>Descrição:</strong> Verificação e ajuste de disjuntores, aterramento e proteção contra surtos.</p>
        <p><strong>Benefício:</strong> Previne choques e incêndios, garantindo segurança</p>
        <p><strong>Exemplo:</strong> Correção de aterramento em condomínio</p>
        <p><strong>Prazo:</strong> Simples (2-4 horas); Complexo (1-2 dias)</p>
        <p><strong>Pagamento:</strong> Simples (completo); Complexo (diagnóstico + parcelado)</p>
        <p><strong>Normas:</strong> IEC 60947, NBR 5410.</p>
        <button class="fechar-btn" @click="fecharModal">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modalAberto: null,
    };
  },
  methods: {
    abrirModal(modalId) {
      this.modalAberto = modalId;
    },
    fecharModal() {
      this.modalAberto = null;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.servico {
  padding: 40px;
  font-family: Arial, sans-serif;
  background-color: #f9f9f9;
}

.servico-section {
  margin-bottom: 60px;
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.servico-section h1,
h2 {
  text-align: center;
  color: #005580;
  margin-bottom: 20px;
}

.servico-section h1 {
  font-size: 28px;
  border-bottom: 2px solid #005580;
  padding-bottom: 10px;
}

.servico-section h2 {
  font-size: 20px;
  font-weight: normal;
}

.servico-img {
  display: block;
  margin: 0 auto 20px auto;
  width: 50%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
}

.servico-lista {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.servico-lista li button {
  background-color: #005580;
  color: white;
  border: none;
  padding: 12px 18px;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 100%;
  text-align: center;
}

.servico-lista li button:hover {
  background-color: #0077a6;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background-color: #fff;
  padding: 30px;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.3s ease-in-out;
}

.modal-content h3 {
  margin-top: 0;
  color: #005580;
  margin-bottom: 20px;
  text-align: center;
}

.modal-content p {
  margin: 10px 0;
  line-height: 1.5;
  color: #333;
}

.fechar-btn {
  display: block;
  margin: 20px auto 0 auto;
  background-color: #cc0000;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.fechar-btn:hover {
  background-color: #e60000;
}

@keyframes fadeIn {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
</style>